var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-treeview',{attrs:{"items":_vm.files,"dense":"","item-children":"content","item-text":"name","open-on-click":"","transition":""},scopedSlots:_vm._u([{key:"prepend",fn:function(ref){
var item = ref.item;
var open = ref.open;
return [(item.type !== 'file')?_c('v-icon',[_vm._v(" "+_vm._s(open ? _vm.icons.folderOpen : _vm.icons.folder)+" ")]):_c('v-icon',[_vm._v(" "+_vm._s(_vm.icons[item.type])+" ")])]}},{key:"label",fn:function(ref){
var item = ref.item;
var open = ref.open;
return [_vm._v(" "+_vm._s(item.name)+" "),(item.type === 'file')?_c('span',{staticClass:"grey--text ml-2"},[_vm._v(" "+_vm._s(_vm.humanize(item.size))+" ")]):_vm._e()]}}])})}
var staticRenderFns = []

export { render, staticRenderFns }